import { Reveal } from "./Reveal";
import { IMAGES } from "../lib/images";

const TILES = [
    {
        img: IMAGES.network,
        label: "Networks & Hardware",
        desc: "Structured LAN, connectivity, and hardware deployment.",
        className: "lg:col-span-2 lg:row-span-2",
        ratio: "aspect-[4/3] lg:aspect-auto lg:h-full",
    },
    {
        img: IMAGES.cctv,
        label: "CCTV & Security",
        desc: "Network-connected camera systems.",
        className: "",
        ratio: "aspect-[4/3]",
    },
    {
        img: IMAGES.starlink,
        label: "Starlink & Connectivity",
        desc: "Installation assistance and setup.",
        className: "",
        ratio: "aspect-[4/3]",
    },
    {
        img: IMAGES.software,
        label: "Software & Platforms",
        desc: "Custom systems, web, and mobile.",
        className: "lg:col-span-2",
        ratio: "aspect-[16/9] sm:aspect-[21/9]",
    },
];

export default function TechShowcase() {
    return (
        <section
            id="showcase"
            data-testid="showcase-section"
            className="bg-white py-20 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
                <Reveal className="mb-12 max-w-2xl">
                    <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand">
                        Solutions Showcase
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl">
                        Technology capabilities, brought together.
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-slate-600">
                        Digital platforms, network infrastructure, connected devices,
                        security systems, and connectivity — implemented with care.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
                    {TILES.map((t, i) => (
                        <Reveal
                            key={t.label}
                            delay={i * 0.07}
                            className={t.className}
                        >
                            <figure className="group relative h-full overflow-hidden rounded-2xl border border-slate-200 shadow-sm">
                                <img
                                    src={t.img}
                                    alt={`${t.label} — ${t.desc}`}
                                    loading="lazy"
                                    className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${t.ratio}`}
                                />
                                <div
                                    className="absolute inset-0 bg-gradient-to-t from-navy-deep/85 via-navy/20 to-transparent"
                                    aria-hidden="true"
                                />
                                <figcaption className="absolute inset-x-0 bottom-0 p-5">
                                    <p className="font-display text-lg font-semibold text-white">
                                        {t.label}
                                    </p>
                                    <p className="mt-0.5 text-xs text-slate-200">
                                        {t.desc}
                                    </p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
